import {
    UsersUpdateOrganizationMembershipInput,
    WellPermissionsSetInput,
} from "../../generated/graphql"
import { FormI } from "./types"
import _ from "lodash"

export const isSubmitFormDisabled = (
    initialForm: FormI,
    form: FormI,
    mutationError: boolean,
    isLoading: boolean
): boolean => {
    if (mutationError || isLoading) {
        return true
    }
    return _.isEqual(initialForm, form)
}

export const getWellPermissionsSetInput = (
    form: FormI
): WellPermissionsSetInput => {
    return {
        membershipID: form.organizationMembershipId,
        wellIDs: form.wellPermissions
            .filter((well) => well.isSelected)
            .map((well) => well.value),
    }
}

export const getUsersUpdateOrganizationMembershipInput = (
    form: FormI
): UsersUpdateOrganizationMembershipInput => {
    const updatedManagedAccess = !form.fullAccess // if fullAccess is false, then we need to set managedAccess to true

    return {
        users: [
            {
                userID: form.targetSubjectId,
                managedAccess: updatedManagedAccess,
            },
        ],
    }
}
